<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/3">
        <DataInput
          v-model="internalValue.name"
          required
          class="w-full mt-4"
          label="Name"
          name="name"
        />
      </div>
      <div class="vx-col w-full md:w-1/3">
        <DataInput
          v-model="internalValue.name2"
          required
          class="w-full mt-4"
          label="Name 2"
          name="name2"
        />
      </div>
      <div class="vx-col w-full md:w-1/3">
        <DataInput
          v-model="internalValue.name3"
          required
          class="w-full mt-4"
          label="Name 3"
          name="name3"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2">
        <DataInput
          v-model="internalValue.salutation"
          class="w-full mt-4"
          label="Anrede"
          name="salutation"
        />
      </div>
      <div class="vx-col w-full lg:w-1/2">
        <DataInput
          v-model="internalValue.letterSalutation"
          class="w-full mt-4"
          label="Brief Anrede"
          name="letterSalutation"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <DataInput
          v-model="internalValue.street"
          class="w-full mt-4"
          label="Name 3"
          name="street"
        />
      </div>
      <div class="vx-col w-full lg:w-1/2">
        <DataInput
          v-model="internalValue.zip"
          class="w-full mt-4"
          label="PLZ"
          name="zip"
        />
      </div>
      <div class="vx-col w-full lg:w-1/2">
        <DataInput
          v-model="internalValue.city"
          class="w-full mt-4"
          label="Stadt"
          name="city"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/3">
        <DataInput
          v-model="internalValue.telephone"
          type="tel"
          class="w-full mt-4"
          label="Telefon"
          name="telephone"
        />
      </div>
      <div class="vx-col w-full lg:w-1/3">
        <DataInput
          v-model="internalValue.telephone2"
          type="tel"
          class="w-full mt-4"
          label="Telefon 2"
          name="telephone2"
        />
      </div>
      <div class="vx-col w-full lg:w-1/3">
        <DataInput
          v-model="internalValue.fax"
          class="w-full mt-4"
          label="Fax"
          name="fax"
        />
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full lg:w-1/2">
        <DataInput
          v-model="internalValue.email"
          class="w-full mt-4"
          label="E-Mail"
          name="email"
        />
      </div>
      <div class="vx-col w-full lg:w-1/2">
        <DataInput
          v-model="internalValue.homepage"
          class="w-full mt-4"
          label="Homepage"
          name="homepage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DataInput from "@/components/ui/DataInput";

export default {
  components: {
    DataInput
  },
  props: {
    value: { type: Object, required: true }
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  watch: {
    internalValue: {
      deep: true,
      handler(v) {
        this.internalValue = v;
      }
    }
  }
};
</script>
